import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * MDTFrame — cornice "Panasonic Toughbook" persistente che avvolge l'INTERA
 * dashboard operatori (sidebar + main), a schermo pieno. Il chrome della
 * cornice (top brand, tasti fisici, footer, angoli, antenna) resta fisso;
 * solo l'area interna scorre.
 *
 * • Applicato SOLO al portale operatori (DashboardLayout). Home/organico/
 *   storia/login non lo vedono mai.
 * • Nessun dato mockato: l'unica info dinamica è l'orologio UTC.
 * • Su mobile la cornice smette di essere fissa e collassa a estetica CRT.
 */
export default function MDTFrame({ children }) {
  const [clock, setClock] = useState(() => new Date());
  const navigate = useNavigate();
  useEffect(() => {
    const id = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const hhmmss = clock.toISOString().slice(11, 19); // UTC HH:MM:SS

  const goBack = () => {
    // Fallback su home pubblica se non c'è storia disponibile
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <div className="mdt-frame" data-testid="mdt-frame">
      {/* Corner rugged rubber pads (solo desktop) */}
      <div className="mdt-corner mdt-corner-tl" aria-hidden />
      <div className="mdt-corner mdt-corner-tr" aria-hidden />
      <div className="mdt-corner mdt-corner-bl" aria-hidden />
      <div className="mdt-corner mdt-corner-br" aria-hidden />
      <div className="mdt-antenna" aria-hidden />

      {/* TOP BRAND BAR — persistente */}
      <div className="mdt-brand">
        <div className="mdt-brand-left">
          <button
            type="button"
            onClick={goBack}
            className="mdt-back"
            aria-label="Torna indietro"
            title="Torna indietro"
            data-testid="mdt-back-btn"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={2.5} />
          </button>
          <div className="mdt-model">
            PANASONIC · <b>TOUGHBOOK</b> · CF-33-LSSD
          </div>
          <span className="mdt-leds" aria-hidden>
            <span className="mdt-led mdt-led-green" title="SIG" /> SIG
            <span className="mdt-led mdt-led-green" title="GPS" /> GPS
            <span className="mdt-led mdt-led-amber" title="BAT" /> BAT
          </span>
        </div>
        <div className="mdt-brand-right">
          <span className="mdt-brand-meta">UTC <b>{hhmmss}</b></span>
          <span className="mdt-badge-conn" data-testid="mdt-connected-badge">
            <span className="mdt-badge-dot" />
            LSSD MOBILE DATA TERMINAL · CONNECTED
          </span>
        </div>
      </div>

      {/* SIDE KEYS — solo desktop */}
      <div className="mdt-side mdt-side-left" aria-hidden>
        <div className="mdt-key mdt-key-led">F1</div>
        <div className="mdt-key">F2</div>
        <div className="mdt-key">F3</div>
        <div className="mdt-key">F4</div>
        <div className="mdt-key mdt-key-round">▲</div>
        <div className="mdt-key mdt-key-round">▼</div>
        <div className="mdt-key">ESC</div>
      </div>
      <div className="mdt-side mdt-side-right" aria-hidden>
        <div className="mdt-key mdt-key-power">
          ⏻<span className="mdt-key-sub">PWR</span>
        </div>
        <div className="mdt-key">MIC</div>
        <div className="mdt-key">VOL+</div>
        <div className="mdt-key">VOL-</div>
        <div className="mdt-key">SOS</div>
        <div className="mdt-key">10-8</div>
        <div className="mdt-key">MENU</div>
      </div>

      {/* CRT SCREEN — l'unica parte che scorre */}
      <div className="mdt-crt">
        <div className="mdt-scanlines" aria-hidden />
        <div className="mdt-vignette" aria-hidden />
        <div className="mdt-crt-content">{children}</div>
      </div>

      {/* BOTTOM FOOTER — persistente */}
      <div className="mdt-foot">
        <span>PANASONIC · TOUGHBOOK · MK-VII</span>
        <span className="mdt-foot-rating">IP65 · MIL-STD-810H · 13.3&quot; 1200 NIT</span>
        <span>LSSD · FIELD UNIT</span>
      </div>
    </div>
  );
}
